import { render } from "./homeGoods.vue?vue&type=template&id=d26047c6"
import script from "./homeGoods.vue?vue&type=script&lang=js"
export * from "./homeGoods.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__